"use strict";
// simplified implementation of mixpanel's super properties
// based on https://github.com/mixpanel/mixpanel-js/blob/3623fe0132860386eeed31756e0d7eb4e61997ed/src/mixpanel-persistence.js#L189-L224
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuperProperties = getSuperProperties;
exports.registerSuperProperties = registerSuperProperties;
exports.registerSuperPropertiesOnce = registerSuperPropertiesOnce;
exports.resetSuperProperties = resetSuperProperties;
const constants_1 = require("./constants");
const utils_1 = require("./utils");
function setSuperProperties(properties) {
    if (!(0, utils_1.isBrowser)()) {
        return;
    }
    localStorage.setItem(constants_1.SUPER_PROPERTIES_KEY, JSON.stringify(properties));
}
/**
 * Retrieves the super properties from the local storage.
 */
function getSuperProperties() {
    if (!(0, utils_1.isBrowser)()) {
        return;
    }
    try {
        const value = localStorage.getItem(constants_1.SUPER_PROPERTIES_KEY);
        if (!value) {
            return undefined;
        }
        return JSON.parse(value);
    }
    catch (e) {
        return undefined;
    }
}
/**
 * Registers super properties by merging the provided properties with existing super properties.
 * If a property already exists, it **will be** overwritten.
 */
function registerSuperProperties(properties) {
    var _a;
    const superProperties = Object.keys(properties).reduce((acc, key) => {
        acc[key] = properties[key];
        return acc;
    }, (_a = getSuperProperties()) !== null && _a !== void 0 ? _a : {});
    setSuperProperties(superProperties);
}
/**
 * Registers super properties once by merging the provided properties with the existing super properties.
 * If a property already exists, it **will not be** overwritten.
 */
function registerSuperPropertiesOnce(properties) {
    var _a;
    const superProperties = Object.keys(properties).reduce((acc, key) => {
        if (!acc.hasOwnProperty(key)) {
            acc[key] = properties[key];
        }
        return acc;
    }, (_a = getSuperProperties()) !== null && _a !== void 0 ? _a : {});
    setSuperProperties(superProperties);
}
/**
 * Resets the super properties stored in the local storage.
 */
function resetSuperProperties() {
    if (!(0, utils_1.isBrowser)()) {
        return;
    }
    localStorage.removeItem(constants_1.SUPER_PROPERTIES_KEY);
}
//# sourceMappingURL=persistence.js.map